import React from 'react';
import { useSelector } from 'react-redux';
import { useInView } from "react-intersection-observer";
import Text from '../../../../../../shared/components/features/text/Text';
import CountUp from "react-countup";
import classes from './InfoNumbers.module.css';

const InfoNumbers = ({ infoNumbers }) => {
    const { texts } = useSelector((state) => state.translate);
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1
    });

    return (
        <div className={`${classes.InfoNumbers} ${classes.InfoSection}`}>
            {infoNumbers?.map(infoNumber =>
                <div key={infoNumber.signNumber} className={classes.InfoNumber}>
                    <div className={classes.NumberWrapper}>
                        <p className={classes.SignNumber}>{infoNumber.signNumber}</p>
                        <div className={classes.Number} ref={ref}>
                            {inView ? <CountUp start={0} end={infoNumber.number} duration={1} decimals={(infoNumber.number % 1 !== 0) ? 1 : 0} /> : <span>{0}</span>}
                        </div>
                    </div>
                    <Text className={classes.Text}>{texts[infoNumber.text]}</Text>
                </div>
            )}
        </div>
    )
}

export default InfoNumbers;